module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-bottom"
  }, [_c('shopping-bar', {
    attrs: {
      "icon": "present",
      "price": "123.4",
      "total": "10"
    },
    on: {
      "on-click": _vm.onclick
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-191c5936!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/shopping-bar/demo.vue
// module id = 228
// module chunks = 21